import './LaserFlow.css';

// Simple fallback without THREE.js dependency
const LaserFlow = () => {
  return (
    <div className="laser-flow-fallback">
      <div className="laser-flow-content">
        <div className="laser-line"></div>
        <div className="laser-line"></div>
        <div className="laser-line"></div>
      </div>
    </div>
  );
};

export default LaserFlow;